import React from 'react'
import { Card, Row, Col, Button } from 'react-bootstrap'

export default function EmptyTeamCard({ handleShowAddToTeam }) {
  return (
    <Card className='border-0 axs-shadow p-3' style={{height: '250px', borderRadius: '16px'}}>
      <Card.Body className='d-flex flex-column justify-content-between'>
        <Row>
          <Col>
            <h5>Location Team</h5>
          </Col>
        </Row>
        <Row>
          <Col className='font-weight-light'>
            <p>By adding to a location’s team, any notifications to that location will be delivered to Jane Doe and the other team members.</p>
          </Col>
        </Row>
        <Row>
          <Col xs='4'>
            <Button block variant='success' onClick={handleShowAddToTeam}>Add to Team</Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  )
}
